import { UserFilterBuilderOptions } from '@/shared/filters/entity-filters/user-filter-builder/user-filter-builder.types';
import { FilterBuilder } from '@/shared/filters/filter-builder';
import { UserFilterInput } from '@/shared/types/types.generated';

export class UserFilterBuilder extends FilterBuilder<
  UserFilterInput,
  UserFilterBuilder
> {
  public allowedFilters: Array<keyof UserFilterInput> = [
    'name',
    'source',
    'creationTimestamp',
    'groupId',
  ];

  constructor(options?: UserFilterBuilderOptions) {
    super();

    // Backoffice maps the `name` search to `fullNameLower` (lowercased).
    if (options?.nameField) {
      this.fieldMappings = {
        name: options.nameField as keyof UserFilterInput,
      };
      this.valueTransformers = {
        name: (value: string) => value.toLowerCase(),
      };
    }
  }
}
